import React, { useEffect, useRef, useState } from 'react';
import styles from './Approve.module.css';
import { useTranslation } from 'react-i18next';

const Approve = ({ toRegister, sendAgaing, email, title }) => {
  const Ref = useRef(null);
  const { t } = useTranslation();
  const [timer, setTimer] = useState("00:00:00");
  const [sended, setSended] = useState(true)
  const [sendedAgain, setSendedAgain] = useState()

  const getTimeRemaining = (e) => {
    const total =
      Date.parse(e) - Date.parse(new Date());
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor(
      (total / 1000 / 60) % 60
    );
    const hours = Math.floor(
      (total / 1000 / 60 / 60) % 24
    );
    return {
      total,
      hours,
      minutes,
      seconds,
    };
  };

  const startTimer = (e) => {
    let { total, hours, minutes, seconds } =
      getTimeRemaining(e);
    if (total >= 0) {
      setTimer(
        (hours > 9 ? hours : "0" + hours) +
        ":" +
        (minutes > 9
          ? minutes
          : "0" + minutes) +
        ":" +
        (seconds > 9 ? seconds : "0" + seconds)
      );
    } else {
      clearInterval(Ref.current);
      setSended(false);
    }
  };

  const clearTimer = (e) => {
    setTimer("00:01:00");

    if (Ref.current) clearInterval(Ref.current);
    const id = setInterval(() => {
      startTimer(e);
    }, 1000);
    Ref.current = id;
  };

  const getDeadTime = () => {
    let deadline = new Date();

    deadline.setSeconds(deadline.getSeconds() + 60);
    return deadline;
  };

  const handleClick = () => {
    sendAgaing && sendAgaing();

    setSendedAgain(true);
  }

  useEffect(() => {
    clearTimer(getDeadTime());

    sendAgaing();
  }, []);

  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.title}>
          {title || t('approve.title')}
        </div>

        <div className={styles.description}>
          {t('approve.description', { email })}
        </div>

        {!sended && !sendedAgain && (
          <div className={styles.linkSendAgain} onClick={handleClick}>
            {t('approve.linkAgain')}
          </div>
        )}

        {sended && !sendedAgain && (
          <div className={styles.timer}>
            {t('approve.linkAgain.timer', { time: timer })}
          </div>
        )}

        {sendedAgain && (
          <div className={styles.linkSendAgain}>
            {t('approve.linkAgain.sended')}
          </div>
        )}

        <div className={styles.linkToRegister} onClick={toRegister}>
          {t('approve.linkRegister')}
        </div>
      </div>
    </div>
  )
}

export default Approve;
